import React from "react";
import Client from "../../../../../Objects/models/Client";
// import IndexStep from "../../../../../App/Courses/Declaration/IndexStep";
import { DataChildType, DataDisptachType } from "../../CourseDeclare";
import moment from "moment/moment";
import Functions from "../../../../../Helpers/Functions";
import {
  capitalizeFirstLetter,
  // fullNameChild,
} from "../../../../../Utils/Function";
import { PunctualCourse } from "../../../../../Objects/models/PunctualCourse";
import PunctualCourseRepository from "../../../../../Repositories/PunctualCourseRepository";
import { useMutation } from "@tanstack/react-query";
// import ToolTip from "../../../../../Utils/ToolTip";
import { CourseType, courseTypes, errorMessages } from "../../staticData";
import { APIErrorEnum } from "../../../../../Objects/enums/APIErrorEnum";
import Swal from "sweetalert2";
import IndexStep from "../../../../../App/DeclarationCourse/IndexStep";

type Props = {
  client?: Client;
  generalStep: any;
  handleChangeStep: (val: number) => void;
  dataChild: DataChildType;
  dataDispatch: DataDisptachType;
};

function createCourseObject(generalStep: any) {
  const isCourseInTheHour = generalStep?.courseType === "urgent";
  // || generalStep.courseType === "punctual";
  const newCourse = new PunctualCourse(
    Boolean(generalStep?.firstStep?.child.parent_id)
      ? `/children/${generalStep?.firstStep?.child.id}`
      : undefined, // forChild
    `/addresses/${generalStep.thirdStep.selectedAddress.id}`, // address
    String(generalStep?.secondStep?.duration * 2), // duration
    generalStep?.secondStep?.endDatetime, // endDatetime
    false, // isFiscalReductionEnabled
    isCourseInTheHour, // isCourseInTheHour
    Boolean(generalStep?.firstStep?.child.parent_id)
      ? undefined
      : `/children/${generalStep?.firstStep?.child.id}`, // forClient
    false, // isDirectCourse
    "Introduction à la programmation", // chapter
    generalStep?.secondStep?.startDatetime, // startDatetime
    `/subjects/${generalStep.thirdStep.selectedSubject.id}`, // subjectAsked
    "CARD", // paymentMean
    0 // directAskedTeachr
    // generalStep?.thirdStep?.selectedFormat.code // format
  );
  newCourse.isRemote =
    generalStep?.thirdStep?.selectedFormat.code === "distance";

  return newCourse;
}

export default function RecapStep({ generalStep, handleChangeStep }: Props) {
  const courseType = generalStep?.courseType as CourseType;
  const courseIsMonth = generalStep?.cours;

  const { mutateAsync, isPending, error, isError } = useMutation({
    mutationKey: ["create-punctual-course"],
    mutationFn: async () => {
      const newCourse = createCourseObject(generalStep);
      return PunctualCourseRepository.createPunctualCourse(newCourse)
    },
    onSuccess: () => {
      handleChangeStep(5);
    },
    onError: (error: any) => {
      const errorLabel =
        errorMessages[error.description as APIErrorEnum] ||
        "Quelque chose s'est mal passée lors de la demande, Veuillez revoir votre demande.";
      Swal.fire({
        icon: "warning",
        title: "Attention !",
        text: errorLabel,
        timer: 2000,
      });
    },
  });

  const errorLabel =
    errorMessages[error?.description as APIErrorEnum] ||
    "Quelque chose s'est mal passée lors de la demande, Veuillez revoir votre demande.";
  // const now = moment();
  const startDatetime = generalStep?.secondStep?.startDatetime;
  const endDatetime = generalStep?.secondStep?.endDatetime;
  // const courseHours = Functions.renderTime(startDatetime);
  // const hoursCondition = courseHours <= now.format("HH:mm");
  // const dayCondition = now.isSame(moment(startDatetime), "day");

  const cours = courseIsMonth;
  const child = generalStep?.firstStep?.child;
  const subject = generalStep?.thirdStep?.selectedSubject;

  // const duration = courseIsMonth
  //   ? generalStep?.secondStep?.durationMore
  //   : generalStep?.secondStep?.duration;

  const duration = generalStep?.secondStep?.duration

  const format = generalStep?.thirdStep?.selectedFormat;
  const address = generalStep?.thirdStep?.selectedAddress;

  const displayBody = () => {
    return (
      <div className="text-normal lg:text-lg md:text-base text-base space-y-4">
        <p>
          Avant de valider votre déclaration, assurez-vous de passer en revue
          chaque information avec attention pour éviter toute erreur.
        </p>
        <div className="list-disc /text-base">
          <li className="font-semibold /text-grey">
            Matière :{" "}
            <span
              onClick={() => handleChangeStep(3)}
              className="font-normal underline cursor-pointer text-first"
            >
              {subject?.fr_FR}
            </span>
          </li>
          <li className="font-semibold /text-grey">
            Durée :{" "}
            <span
              onClick={() => handleChangeStep(2)}
              className="font-normal underline cursor-pointer text-first"
            >
              {Functions.renderDuration(duration * 2)}
            </span>
          </li>
          <li className="font-semibold /text-grey">
            Type de cours :{" "}
            <span
              onClick={() => handleChangeStep(1)}
              className="font-normal underline cursor-pointer text-first"
            >
              {cours ? "Plusieurs cours" : "Ponctuel"}
            </span>{" "}
          </li>
          {/* <ToolTip text={dayCondition &&( hoursCondition ? "L'heure de début du cours que vous avez indiquée est déjà écoulée. Merci de modifier l'heure de début." : "")} > */}
          <li className="font-semibold /text-grey">
            {generalStep.cours ? "Periode des cours" : "Date et heure"} :{" "}
            <span
              onClick={() => handleChangeStep(2)}
              className={` font-normal underline cursor-pointer text-first`}
            // className={`${generalStep.cours ? "" : (dayCondition && (hoursCondition ? "text-third " : ""))} font-normal underline cursor-pointer text-first`}
            >
              {generalStep.cours && "Du"}
              {capitalizeFirstLetter(
                moment(startDatetime).format(cours ? "ll" : "dddd DD MMMM YYYY")
              )}
              {cours ? " au " : " à "}
              {cours
                ? capitalizeFirstLetter(
                  moment(endDatetime).format(
                    cours ? "ll" : "dddd DD MMMM YYYY"
                  )
                )
                : Functions.renderTime(startDatetime)}
            </span>
          </li>
          {/* </ToolTip> */}
          <li className="font-semibold /text-grey">
            Format du cours :{" "}
            <span
              onClick={() => handleChangeStep(1)}
              className="font-normal underline cursor-pointer text-first"
            >
              {format.text}{" "}
              {format.code === "domicile" ? (
                <span>({address.formattedAddress})</span>
              ) : null}
            </span>
          </li>
          <li className="font-semibold /text-grey">
            Élève :{" "}
            <span
              onClick={() => handleChangeStep(1)}
              className="font-normal underline cursor-pointer text-first"
            >
              {child?.firstName}
            </span>
          </li>
        </div>
        <p>
          Une fois la demande de paiement transmise à l'Urssaf, votre client
          sera informé par e-mail. Il disposera alors de 48 heures pour valider
          ou contester le paiement. Si aucune action n’est effectuée dans ce
          délai, le paiement sera automatiquement validé.
        </p>
        {isError ? <small>{errorLabel}</small> : null}
      </div>
    );
  };

  return (
    <IndexStep
      title={`${courseTypes[courseType]} 📚`}
      body={displayBody()}
      load={isPending}
      handleChangeStep={handleChangeStep}
      handleNexStep={() => mutateAsync()}
      value={5}
      step={4}
      generalStep={generalStep}
    />
  );
}
